import addClasses from '{dede:global.cfg_basehost/}/addClasses.js';
import removeClasses from '{dede:global.cfg_basehost/}/removeClasses.js';

export default { addClasses, removeClasses };
